import { useEffect, useState } from "react";
import Movie from "../components/Movie";
import styled from "styled-components";

// 🌟 스타일 적용 (그리드 레이아웃)
const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
`;

const Title = styled.h1`
  text-align: center;
  font-size: 28px;
  margin-bottom: 20px;
  color: ${(props) => props.theme.text};
`;

const MovieGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 20px;
`;

const LoadingText = styled.p`
  text-align: center;
  font-size: 18px;
  color: ${(props) => props.theme.text};
`;

function Home() {
  const [movies, setMovies] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(
      "https://yts.mx/api/v2/list_movies.json?minimum_rating=8.8&sort_by=year"
    )
      .then((response) => response.json())
      .then((data) => {
        setMovies(data.data.movies);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching movies:", error);
        setLoading(false);
      });
  }, []);

  return (
    <Container>
      <Title>🎬 최신 영화</Title>
      {loading ? (
        <LoadingText>데이터를 불러오는 중...</LoadingText>
      ) : (
        <MovieGrid>
          {movies.map((movie) => (
            <Movie
              key={movie.id}
              id={movie.id}
              coverImg={movie.medium_cover_image}
              rating={movie.rating}
              runtime={movie.runtime}
              title={movie.title}
              summary={movie.summary}
              genres={movie.genres}
            />
          ))}
        </MovieGrid>
      )}
    </Container>
  );
}

export default Home;
